<template>
  <q-drawer
    v-if="component"
    v-model="drawlerVisibility"
    show-if-above
    side="right"
    content-class="bg-grey-2"
    :breakpoint="20000"
    :width="configs.width"
  >
    <component
      :is="component"
      v-bind="props"
      @close="close"
      @ok="ok"
    />
  </q-drawer>
</template>

<script>
import FilterList from '../FilterList';

export default {
  name: 'DrawerSwapContent',
  components: { FilterList },
  data: () => ({
    configs: {
      width: 500,
    },
    drawlerVisibility: false,
    component: null,
    props: {},
  }),
  mounted() {
    this.$g.drawer.right.on(this.handleEvent);
  },
  destroyed() {
    this.$g.drawer.right.off(this.handleEvent);
    this.component = null;
    this.props = {};
  },
  methods: {
    ok(payload) {
      this.$g.drawer.right.message(payload);
      this.drawlerVisibility = false;
    },
    close() {
      this.drawlerVisibility = false;
    },
    handleEvent(action) {
      const events = {
        SHOW: () => {
          this.applyConfigs(action);
          this.drawlerVisibility = true;
        },
        HIDE: () => {
          this.drawlerVisibility = false;
        },
      };
      return events[action.type] && events[action.type]();
    },
    applyConfigs(action) {
      if (!action) return;

      const { width } = action.payload;
      const { component, props } = action.payload;

      this.configs.width = width || this.configs.width;
      this.component = component;
      this.props = {
        ...props,
        ...this.$props,
      };
      this.$forceUpdate();
    },
  },
};
</script>
